"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Adam Drda
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Release Impact DTO converter
 *
 * @author Adam Drda
 */


var ReleaseImpactDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReleaseImpactDTOConverter, _DataObjectConverter_);

  function ReleaseImpactDTOConverter() {
    _classCallCheck(this, ReleaseImpactDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseImpactDTOConverter).apply(this, arguments));
  }

  return ReleaseImpactDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReleaseImpactDTOConverter = ReleaseImpactDTOConverter;